import { render, staticRenderFns } from "./Cierres.vue?vue&type=template&id=f0f794c4&"
import script from "./Cierres.vue?vue&type=script&lang=js&"
export * from "./Cierres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports